/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */

export default {
	'Type something': 'Begin met typen..',
	Advanced: 'Geavanceerd',
	'About Jodit': 'Over Jodit',
	'Jodit Editor': 'Jodit Editor',
	'Free Non-commercial Version': 'Gratis niet-commerciële versie',
	"Jodit User's Guide": 'Jodit gebruikershandleiding',
	'contains detailed help for using':
		'bevat gedetailleerde informatie voor gebruik.',
	'For information about the license, please go to our website:':
		'Voor informatie over de licentie, ga naar onze website:',
	'Buy full version': 'Volledige versie kopen',
	'Copyright © XDSoft.net - Chupurnov Valeriy. All rights reserved.':
		'Copyright © XDSoft.net - Chupurnov Valeriy. Alle rechten voorbehouden.',
	Anchor: 'Anker',
	'Open in new tab': 'Open in nieuwe tab',
	'Open in fullsize': 'Editor in volledig scherm openen',
	'Clear Formatting': 'Opmaak verwijderen',
	'Fill color or set the text color': 'Vulkleur of tekstkleur aanpassen',
	Redo: 'Opnieuw',
	Undo: 'Ongedaan maken',
	Bold: 'Vet',
	Italic: 'Cursief',
	'Insert Unordered List': 'Geordende list invoegen',
	'Insert Ordered List': 'Ongeordende lijst invoegen',
	'Align Center': 'Centreren',
	'Align Justify': 'Uitlijnen op volledige breedte',
	'Align Left': 'Links uitlijnen',
	'Align Right': 'Rechts uitlijnen',
	'Insert Horizontal Line': 'Horizontale lijn invoegen',
	'Insert Image': 'Afbeelding invoegen',
	'Insert file': 'Bestand invoegen',
	'Insert youtube/vimeo video': 'Youtube/Vimeo video invoegen',
	'Insert link': 'Link toevoegen',
	'Font size': 'Tekstgrootte',
	'Font family': 'Lettertype',
	'Insert format block': 'Format blok invoegen',
	Normal: 'Normaal',
	'Heading 1': 'Koptekst 1',
	'Heading 2': 'Koptekst 2',
	'Heading 3': 'Koptekst 3',
	'Heading 4': 'Koptekst 4',
	Quote: 'Citaat',
	Code: 'Code',
	Insert: 'Invoegen',
	'Insert table': 'Tabel invoegen',
	'Decrease Indent': 'Inspringing verkleinen',
	'Increase Indent': 'Inspringing vergroten',
	'Select Special Character': 'Symbool selecteren',
	'Insert Special Character': 'Symbool invoegen',
	'Paint format': 'Opmaak kopieren',
	'Change mode': 'Modus veranderen',
	Margins: 'Marges',
	top: 'Boven',
	right: 'Rechts',
	bottom: 'Onder',
	left: 'Links',
	Styles: 'CSS styles',
	Classes: 'CSS classes',
	Align: 'Uitlijning',
	Right: 'Rechts',
	Center: 'Gecentreerd',
	Left: 'Links',
	'--Not Set--': '--Leeg--',
	Src: 'Src',
	Title: 'Titel',
	Alternative: 'Alternatieve tekst',
	Link: 'Link',
	'Open link in new tab': 'Link in nieuwe tab openen',
	Image: 'Afbeelding',
	file: 'Bestand',
	'Image properties': 'Afbeeldingseigenschappen',
	Cancel: 'Annuleren',
	Ok: 'OK',
	'Your code is similar to HTML. Keep as HTML?':
		'Deze code lijkt op HTML. Als HTML behouden?',
	'Paste as HTML': 'Invoegen als HTML',
	Keep: 'Origineel behouden',
	Clean: 'Opschonen',
	'Insert as Text': 'Als tekst invoegen',
	'Word Paste Detected': 'Word-tekst gedetecteerd',
	'The pasted content is coming from a Microsoft Word/Excel document. Do you want to keep the format or clean it up?':
		'De geplakte tekst is afkomstig van een Microsoft Word/Excel document. Wil je de opmaak behouden of opschonen?',
	'Insert only Text': 'Als onopgemaakte tekst invoegen',
	'File Browser': 'Bestandsbrowser',
	'Error on load list': 'Fout bij het laden van de lijst',
	'Error on load folders': 'Fout bij het laden van de mappenlijst',
	'Are you sure?': 'Weet je het zeker?',
	'Enter Directory name': 'Geef de map een naam',
	'Create directory': 'Map aanmaken',
	'type name': 'Type naam',
	'Drop image': 'Sleep hier een afbeelding naartoe',
	'Drop file': 'Sleep hier een bestand naartoe',
	'or click': 'of klik',
	'Alternative text': 'Alternatieve tekst',
	Browse: 'Bladeren',
	Upload: 'Uploaden',
	Background: 'Achtergrond',
	Text: 'Tekst',
	Top: 'Boven',
	Middle: 'Midden',
	Bottom: 'Onder',
	'Insert column before': 'Kolom invoegen (voor)',
	'Insert column after': 'Kolom invoegen (na)',
	'Insert row above': 'Rij invoegen (boven)',
	'Insert row below': 'Rij invoegen (onder)',
	'Delete table': 'Tabel verwijderen',
	'Delete row': 'Rij verwijderen',
	'Delete column': 'Kolom verwijderen',
	'Empty cell': 'Cel leegmaken',
	Delete: 'Verwijderen',
	'Strike through': 'Doorstrepen',
	Underline: 'Onderstrepen',
	Break: 'Enter',
	'Search for': 'Zoek naar',
	'Replace with': 'Vervangen door',
	Replace: 'Vervangen',
	Edit: 'Bewerken',
	'Vertical align': 'Verticaal uitlijnen',
	'Horizontal align': 'Horizontaal uitlijnen',
	Filter: 'Filteren',
	'Sort by changed': 'Sorteren op wijzigingsdatum',
	'Sort by name': 'Sorteren op naam',
	'Sort by size': 'Sorteren op grootte',
	'Add folder': 'Map toevoegen',
	Split: 'Splitsen',
	'Split vertical': 'Verticaal splitsen',
	'Split horizontal': 'Horizontaal splitsen',
	Merge: 'Samenvoegen',
	'Add column': 'Kolom toevoegen',
	'Add row': 'Rij toevoegen',
	Border: 'Rand',
	'Embed code': 'Embed code',
	Update: 'Updaten',
	superscript: 'Superscript',
	subscript: 'Subscript',
	'Cut selection': 'Selectie knippen',
	Paste: 'Plakken',
	'Choose Content to Paste': 'Kies content om te plakken',
	'Chars: %d': 'Tekens: %d',
	'Words: %d': 'Woorden: %d',
	All: 'Alles',
	'Select %s': 'Selecteer: %s',
	'Select all': 'Selecteer alles',
	source: 'Broncode',
	bold: 'vet',
	italic: 'cursief',
	brush: 'kwast',
	link: 'link',
	undo: 'ongedaan maken',
	redo: 'opnieuw',
	table: 'tabel',
	image: 'afbeelding',
	eraser: 'gum',
	paragraph: 'paragraaf',
	fontsize: 'lettergrootte',
	video: 'video',
	font: 'lettertype',
	about: 'over',
	print: 'afdrukken',
	underline: 'onderstreept',
	strikethrough: 'doorgestreept',
	indent: 'inspringen',
	outdent: 'minder inspringen',
	fullsize: 'volledige grootte',
	shrink: 'kleiner maken',
	hr: 'horizontale lijn',
	ul: 'lijst',
	ol: 'genummerde lijst',
	cut: 'knip',
	selectall: 'alles selecteren',
	'Open link': 'Link openen',
	'Edit link': 'Link aanpassen',
	'No follow': 'Niet volgen',
	Unlink: 'link verwijderen',
	Eye: 'Recensie',
	pencil: 'Om te bewerken',
	' URL': ' URL',
	Reset: 'Herstellen',
	Save: 'Opslaan',
	'Save as ...': 'Opslaan als ...',
	Resize: 'Grootte aanpassen',
	Crop: 'Bijknippen',
	Width: 'Breedte',
	Height: 'Hoogte',
	'Keep Aspect Ratio': 'Verhouding behouden',
	Yes: 'Ja',
	No: 'Nee',
	Remove: 'Verwijderen',
	Select: 'Selecteren',
	'You can only edit your own images. Download this image on the host?':
		'Je kunt alleen je eigen afbeeldingen aanpassen. Deze afbeelding downloaden?',
	'The image has been successfully uploaded to the host!':
		'De afbeelding is succesvol geüploadet!',
	palette: 'Palette',
	'There are no files': 'Er zijn geen bestanden in deze map.',
	Rename: 'Hernoemen',
	'Enter new name': 'Voer een nieuwe naam in',
	preview: 'Voorvertoning',
	download: 'Download',
	'Paste from clipboard': 'Plakken van klembord',
	"Your browser doesn't support direct access to the clipboard.":
		'Uw browser ondersteunt geen directe toegang tot het klembord.',
	'Copy selection': 'Selectie kopiëren',
	copy: 'kopiëren',
	'Border radius': 'Border radius',
	'Show all': 'Toon alle',
	Apply: 'Toepassen',
	'Please fill out this field': 'Vul dit veld in',
	'Please enter a web address': 'Voer een webadres in',
	Default: 'Standaard',
	Circle: 'Cirkel',
	Dot: 'Punt',
	Quadrate: 'Kwadraat',
	Find: 'Zoeken',
	'Find Previous': 'Vorige Zoeken',
	'Find Next': 'Volgende Zoeken',
	'Insert className': 'Voeg de klassenaam in',
	'Press Alt for custom resizing': 'Druk op Alt voor aangepaste grootte'
};
